module.exports = __webpack_public_path__ + "static/media/Northvolt.7c2eb705.png";